import { render } from "./BayerView.vue?vue&type=template&id=6eefb97e&scoped=true"
import script from "./BayerView.vue?vue&type=script&lang=js"
export * from "./BayerView.vue?vue&type=script&lang=js"

import "./BayerView.vue?vue&type=style&index=0&id=6eefb97e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eefb97e"]])

export default __exports__